module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid14_800x662.3eb9878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid14_800x662.jpg
// module id = Rdyx
// module chunks = 0